<template>
  <div v-if="((dashboardPage == 'project-pricing' || dashboardPage == 'project-tasks' || dashboardPage == 'project-phases' || dashboardPage == 'project-totals') && currentProjectName) || !(dashboardPage == 'project-pricing' || dashboardPage == 'project-tasks' || dashboardPage == 'project-phases' || dashboardPage == 'project-totals')" @click="test()" class="header-full-width" :class="{'header4' : (headerMode == 'partial' || headerMode == 'partial_limited'), 'space-for-verification-reminder': !userData.emailVerified,
  'menu-on': showProfileMenu}">
    <div class="header df fdr aic" :class="{
      'header2' : (headerMode == 'partial') || (headerMode == 'partial_limited'),
      'header3' : headerMode == 'partial',
      'header3b' : headerMode == 'partial_limited'
    }">
    <!--  <div v-if="tokenData.email" class="top-section df fdr jcsb">

        <img @click="goTo('/')" class="logo-small" src="/images/hplogo.png" alt="">

      </div>-->
      <div class="top-section df aic fdr jcsb">

        <div v-if="(headerMode == 'partial' || (headerMode == 'partial_limited'))" class="links2 df fdr">

          <img @click="animateThenGoTo('/projects')" v-if="animatingSave" class="logo-small logo-small-loading" src="/images/loading3.gif" alt="">
          <img @click="animateThenGoTo('/projects')" v-else class="logo-small" src="/images/hplogo.png" alt="">

          <span
            @click="closePage('/projects')"
            v-if="headerMode == 'partial_limited'"
            class="header-save-exit nexa-font-bold">
              Save and Exit
          </span>
        </div>
        <!-- <h2 class="nexa-font-bold" v-if="headerMode == 'full' && companyName">{{ companyName }}</h2> -->
        <img @click="goTo('/projects')" v-if="headerMode == 'full'" class="logo" src="/images/hplogo_no-title.png" alt="">
        <!-- <img @click="goTo('/projects')" v-if="headerMode == 'full'" class="logo logo--mobile" src="/images/logo-hourprice-icon-blue.svg" alt=""> -->
      </div>
      <div v-if="headerMode == 'full'" class="header-right df">
        <div class="links df">
          <router-link :to="'explore'" :class="{'current-page': dashboardPage == 'explore'}">
            <p class="tab-text">Explore</p>
          </router-link>
          <router-link :to="'projects'" :class="{'current-page': dashboardPage == 'project'}">
            <p class="tab-text">Projects</p>
          </router-link>
          <router-link :to="'tasks'" :class="{'current-page': dashboardPage == 'tasks'}">
            <p class="tab-text">Tasks</p>
          </router-link>
          <span class="df aic">
            <button class="new-project" @click="addNewProject">
              <span class="mobile-hidden">New Project</span>
              <img src="/images/Icon-plus.svg" alt="">
            </button>
          </span>
        </div>
      </div>
      <div class="df aic">
        <span class="df fdr jcc aic name-profile-wrapper" @click="toggleProfileMenu()">
          <p class="name-profile gg-font">{{ userData.fullName }}</p>
          <img class="chevron-down" src="/images/arrow-red-active-down.svg" alt="">
          <img class="avatar" :src="userData.profileImage ? userData.profileImage : '/images/avatar-deault-grey-circle.svg'" alt="">
        </span>
      </div>
      <!-- ,,, -->
      <div v-if="showProfileMenu" class="profile-menu df fdc jcsb" v-closable="{handler: 'onClose'}">
        <div class="identity df fdr jcsb">
          <img class="profile-image" :src="userData.profileImage ? userData.profileImage : '/images/profile_image_placeholder.jpeg'" alt="">
          <div class="user-details df fdc jcc">
            <span class="full-name nexa-font-bold">
              <p>
                {{ userData.fullName }}
              </p>
            </span>
            <span class="e-mail gg-font">
              <p>
                {{ userData.email }}
              </p>
            </span>
          </div>
        </div>
        <div class="profile-menu-links">
          <!-- <span class="gg-font" @click="goToProfile()">
            <p>
              View Profile
            </p>
          </span>
          <span class="gg-font" @click="goTo('/pricing')">
            <p>
              Upgrade Plan
            </p>
          </span> -->
          <router-link class="gg-font" :to="'profile'">
            <p>
              Account
            </p>
          </router-link>
          <span class="gg-font" @click="signOut()">
            <p>
              Sign Out
            </p>
          </span>
        </div>
      </div>





      <div v-if="!userData.emailVerified" class="verify-email df fdr aic">
        <p>Awaiting Email Confirmation.</p>
        &nbsp;
        <span class="resend-link" @click="resendEmailVerification()">Resend Email?</span>
        &nbsp;
        <span class="reset-email-sent" v-if="showEmailResetLink" :class="{'reset-email-sent-flash': flashEmailResetLink}">Reset e-mail sent.</span>
      </div>
    </div>
    <CreateNewProject v-if="creatingNewProject" @closeNewProject="closeNewProject"/>
  </div>
</template>

<script>
import router from '../../router'
import { mapGetters } from 'vuex'
import CreateNewProject from '../project/CreateNewProject'

export default {
  name: 'DashboardHeader',
  data () {
    return {
      showProfileMenu: false,
      flashEmailResetLink: false,
      showEmailResetLink: false,
      animatingSave: false,
      creatingNewProject: false
    }
  },
  props: ['dashboardPage', 'headerMode'],
  components: {
    CreateNewProject
  },
  methods: {
    test () {
      // console.log('***', this.tokenData.email);
    },
    resendEmailVerification () {
      this.$store.dispatch('resendEmailVerification', {
        key: this.verificationKey,
        url: window.location.origin,
      }).then(() => {
        console.log('after resendEmailVerification')
        this.showEmailResetLink = true
        setTimeout(()=>{
          this.flashEmailResetLink = true
          setTimeout(()=>{
            this.showEmailResetLink = false
            this.flashEmailResetLink = false
          }, 1000)
        }, 250)
      })
    },
    addNewTask () {

    },
    onClose () {
      console.log('onClose')
      this.showProfileMenu = false
    },
    goTo (path) {
      this.showProfileMenu = false
      router.push(path)
    },
    animateThenGoTo (path) {

      this.animatingSave = true
      this.showProfileMenu = false

      setTimeout(()=>{
        this.animatingSave = false
        router.push(path)
      }, 1000)
    },
    closePage(path) {
      // getMyProjects
      this.$store.dispatch("clearProjectData",  {
        projectid: this.$route.params.projectid
      })
      this.$store.dispatch("getMyProjects", {
        projectList: this.$store.getters.myProjectList
      }),
      this.animateThenGoTo(path)
    },
    toggleProfileMenu () {
      if (this.showProfileMenu) {
        this.showProfileMenu = false
      } else {
        setTimeout(() => {
          console.log('toggle', !this.showProfileMenu)
          this.showProfileMenu = !this.showProfileMenu
        }, 50)
      }
    },
    signOut () {
      this.$store.dispatch('logout', {})
    },
    goToProfile () {
      this.showProfileMenu = false
      this.goTo('/profile')
    },
    addNewProject () {
      this.creatingNewProject = true
    },
    closeNewProject () {
      this.creatingNewProject = false
    },
  },
  computed: {
    ...mapGetters([
      'tokenData',
      'companyName',
      'userData',
      'verificationKey',
      'currentProjectName'
    ])
  },
  created () {
    // console.log('** Header Component Loaded', this.userData)
  }
}
</script>

<style scoped lang="scss">
@import "../../styles/settings.scss";
.header {
  min-width: 1280px;
  height: 80px;
  align-self: center;
  /*background-color: #232E37;*/
  background-color: #313131;
  padding: 0 44px;
  position: relative;

  // Responsive Style
  // @media max-width: 1280px
  @media(max-width: 1280px) {
    min-width: 100%;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding: 0 10px;
    /* height: auto;
    padding-top: 20px;
    padding-left: 20px;
    padding-right: 20px;

    // h2
    h2 {
      font-size: 18px;
      position: relative;
      top: 8px;
      padding-left: 47px;
    }

    // top section
    .top-section {margin-bottom: 25px;} */
  }
}


.header-right {
  height: 100%;
}


//
// Header 2
//
.header2 {
  padding: 10px 48px;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-bottom: 10px;
  }
}

.header3 {
  height: 45px;
  width: 100%;
  min-width: unset;
}


//
// Header3b
//
.header3b {
  height: 45px;
  width: 100%;
  min-width: unset;
}

.links {
  height: 100%;
  position: relative;

  a {
    text-decoration: none;
  }

  & > * {
    font-size: 12px;
    margin: 0 18px;
    /* height: 37px; */
    /*width: 80px;*/
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    justify-content: center;

    & > p {
      cursor: pointer;
      font-size: 14px;
      text-transform: uppercase;
      color: white;
      /*height: 24px;*/
      /*width: 80px;*/
      color: #b2b2b2;
      /*font-family: "Nexa Bold";*/
      font-size: 14px;
      letter-spacing: 0.5px;
      /*line-height: 24px;*/
    }

    &:hover {
      & > p {
        color: white;
        /*opacity: 0.8;*/
      }
    }

    // Responsive Style
    // @media max-width: 768px
    /* @media(max-width: 768px) {
      height: 30px;
    } */

    // Responsive Style
    // @media max-width: 580px
    @media(max-width: 580px) {
      margin: 0 8px;
    }
  }

  @media(max-width: 580px) {
    padding-right: 6px;
  }

  &:after {
    content: '';
    position: absolute;
    right: 0;
    height: 50px;
    border-right: 1px solid #565656;
    margin: 15px 0;
  }
}

.links2 > span {
  margin-right: 30px;

  & > p {
    color: white;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1px;
    line-height: 24px;
    text-transform: uppercase;
  }
}

.current-page {
  position: relative;

  &:after {
    content: '';
    border-bottom: 5px solid #F33A7D;
    position: absolute;
    bottom: 0;
    width: 100%;
  }

  p {
    color: white !important;
  }
}

button.new-project {
  height: 32px;
  font-family: 'Nexa';
  font-weight: bold;
  text-transform: uppercase;
  color: #FFF;
  background-color: #F33A7D;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  padding: 0 12px;
  white-space: nowrap;

  @media (max-width: 768px) {
    padding: 0 8px;
  }

  span {
    margin-right: 12px;
  }
}

button.support {
  height: 16px;
  width: 16px;
  background: none;
  margin: auto 24px;
  border: 0;
  padding: 0;
  cursor: pointer;
}

.top-section {
  margin-right: auto;
}

.logo {

  // Responsive Style
  @media(max-width: 768px) {
    display: none;
  }
}


//
// Logo Mobile
//
.logo--mobile {
  display: none;

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    display: block;
    transform: none;
    top: 20px;
    left: 20px;
  }
}



.logo-small {
  width: 25px;
  height: 25px;
  object-fit: contain;
  object-position: center;
  margin-right: 20px;
}

.name-profile {
  color: white;
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.46px;
  line-height: 16px;
  cursor: pointer;
}

.name-profile-wrapper {
  margin-left: 18px;
  cursor: pointer;

  // avatar
  .avatar {
    display: none;
    width: 36px;
    height: 36px;
  }

  // Responsive Style
  // @media max-width: 768px
  @media(max-width: 768px) {
    margin-left: 8px;

    // name profile & chevron
    .name-profile, .chevron-down {display: none;}

    // avatar
    .avatar {display: block;}
  }
}

.chevron-down {
  margin-left: 10px;
}

.profile-menu {
  position: absolute;
  width: 300px;
  border-radius: 8px;
  right: 25px;
  top: 65px;
  background-color: #f5f5f5;
  box-shadow: 0 1px 4px 0 rgba(0,0,0,0.28);
  z-index: 100;
}

.identity {
  padding: 15px 30px;
  border-top-right-radius: 8px;
  border-top-left-radius: 8px;
  background-color: white;
  background-color: $greyBoxGrey;
  /*border-bottom: 1px solid #aaa;*/
}

.user-details {
  flex: 1;
  padding-left: 20px;
}

.profile-image {
  background-color: $highlightColor;
  width: 68px;
  height: 68px;
  border-radius: 50%;
  object-fit: cover;
  object-position: center;
}

.full-name {
  font-size: 16px;
  font-weight: bold;
  color: $grey2;
}

.e-mail {
  font-size: 12px;
  font-weight: 400;
  color: $grey2;
}

.profile-menu-links {
  padding-bottom: 10px;
  padding-top: 10px;
  background-color: white;
  border-bottom-left-radius: $boxBorderRadius;
  border-bottom-right-radius: $boxBorderRadius;

  & > * {
    padding: 5px 30px;
    display: -webkit-flex;
    display: -moz-flex;
    display: -ms-flex;
    display: -o-flex;
    display: flex;
    font-size: 12px;
    text-transform: capitalize;
    font-weight: 400;
    cursor: pointer;
    color: $grey2;
    text-decoration: none;

    p {
      cursor: pointer;
    }

    &:hover {
      background-color: $primaryLightColor;
    }
  }
}

.view-profile {
  /*background-color: white;*/
  /*color: #2c74dc;*/
}

.verify-email {
  min-height: 30px;
  padding: 0 15px;
  background-color: #ffdbdc;
  color: #d84647;
  font-size: 14px;
  height: 30px;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  position: absolute;
  bottom: 0;
  left: 0;
  /*width: calc(100% + 86px);*/
  width: 100vw;
  left: 50%;
  transform: translate(-50%, 100%);


  @media (max-width: 1295px) {
    left: 0;
    transform: translate(0, 100%);
  }
}

.header-full-width {
  /*position: absolute;*/
  z-index: 5;
  top: 0;
  left: 0;
  /*height: 100px;*/
  width: 100vw;
  background-color: #313131;
  display: -webkit-flex;
  display: -moz-flex;
  display: -ms-flex;
  display: -o-flex;
  display: flex;
  -ms-align-items: center;
  align-items: center;
  justify-content: center;
  /*background-color: #232E37;*/
  box-shadow: 0 2px 4px 0 rgba(0,0,0,0.29);
  /*overflow-x: hidden;*/

  @media (max-width: 1295px) {
    align-self: flex-start;
    justify-content: flex-start !important;
  }
}
.space-for-verification-reminder {
  padding-bottom: 30px;
}

//
// Header4
.header4 {
  position: fixed;
  z-index: 111;
  width: 100%;

  .header3 {
    /*max-width: 1280px;*/
  }
}

.menu-on {
  z-index: 111;
}
.resend-link {
  font-weight: 600;
  cursor: pointer;
}
.reset-email-sent {
  /*display: none;*/
  /*opacity: 1;*/
  transition: opacity 1s;
}
.reset-email-sent-flash {
  /*display: block;*/
  opacity: 0;
}

.logo, .logo-small {
  cursor: pointer;
}

.logo-small-loading {
  object-fit: cover;
}

.add {
  transform: translateY(100%);
}
.header-back {
  padding: 0;
  color: white;
  position: absolute;
  margin: 0;
  left: 26px;
  font-size: 23px;
  top: 7px;
}

.header-save-exit {
  color: #B2B2B2;
  text-transform: uppercase;
  font-size: 12px;
  display: flex;
  justify-content: center;
  -ms-align-items: center;
  align-items: center;
}

.tab-text{
  display: flex;
  align-items: center;
  color: #b2b2b2;
  text-decoration: none;
  font-family: "Nexa-Bold" !important;
  font-weight: 600 !important;
  font-size: 14px;
  letter-spacing: 0.5px;


  // Responsive Style
  // @media max-width: 480px
  @media(max-width: 480px) {
    // a
    a {
      font-size: 10px;
    }
  }
}
</style>
